// getAllSlopes
// getSlopeById
// createSlope
// updateSlope
// deleteSlope
// restoreSlope
// bulkImportSlopes

import api from './api'

export const getAllSlopes = async (resortId, options) => {
  try {
    const config = options?.includeArchived
      ? { params: { include_archived: '1' } }
      : undefined
    const response = await api.get(`/slopes/resort/${resortId}`, config)
    return response.data
  } catch (err) {
    console.error('Error fetching slopes:', err)
    throw err
  }
}

export const getSlopeById = async id => {
  try {
    const response = await api.get(`/slopes/${id}`)
    return response.data
  } catch (err) {
    console.error('Error fetching slope:', err)
    throw err
  }
}

export const createSlope = async slopeData => {
  try {
    const response = await api.post('/slopes/add', slopeData)
    return response.data
  } catch (err) {
    console.error('Error creating slope:', err)
    throw err
  }
}

export const updateSlope = async (id, slopeData) => {
  try {
    const response = await api.put(`/slopes/${id}`, slopeData)
    return response.data
  } catch (err) {
    console.error('Error updating slope:', err)
    throw err
  }
}

export const deleteSlope = async id => {
  try {
    const response = await api.delete(`/slopes/${id}`)
    return response.data
  } catch (err) {
    console.error('Error deleting slope:', err)
    throw err
  }
}

export const restoreSlope = async id => {
  try {
    const response = await api.post(`/slopes/${id}/restore`)
    return response.data
  } catch (err) {
    console.error('Error restoring slope:', err)
    throw err
  }
}

export const bulkImportSlopes = async data => {
  try {
    // Get resort ID from current user if not provided
    if (!data.resort_id) {
      const userInfo = JSON.parse(localStorage.getItem('user'))
      data.resort_id = userInfo?.user?.resort_id
    }

    const response = await api.post('/slopes/bulk-import', data)
    return response.data
  } catch (error) {
    console.error('Error bulk importing slopes:', error)
    throw error
  }
}
